import { VStack, Checkbox } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import { useEffect } from "react";

const IsReturnAndPaid = observer(() => {
  const { pageStore } = useStores();

  const handleChange = (field) => (e) => {
    pageStore.updateSelectedViewOpen({
      ...pageStore.selected_view_open,
      [field]: e.target.checked,
    });
  };

  const handleChangeSelf = (field, value) => {
    pageStore.updateSelectedViewOpen({
      ...pageStore.selected_view_open,
      [field]: value,
    });
  };

  useEffect(() => {
    handleChangeSelf("isNotReturn", true);
  }, []);

  return (
    <VStack
      align="start"
      spacing={2}
      bg="#333"
      p={3}
      borderRadius="10px"
      width="250px"
      color="#EEEEEE"
    >
      <Checkbox
        colorScheme="green"
        isChecked={pageStore.selected_view_open?.isReturn == true || false}
        onChange={handleChange("isReturn")}
      >
        Возвратный счёт
      </Checkbox>

      <Checkbox
        colorScheme="green"
        isChecked={pageStore.selected_view_open?.isNotReturn == true || false}
        onChange={handleChange("isNotReturn")}
      >
        Обычный счёт
      </Checkbox>

      <Checkbox
        colorScheme="green"
        isChecked={pageStore.selected_view_open?.isFullShipment || false}
        onChange={handleChange("isFullShipment")}
      >
        100% отгрузки
      </Checkbox>

      <Checkbox
        colorScheme="green"
        isChecked={pageStore.selected_view_open?.isPartialShipment || false}
        onChange={handleChange("isPartialShipment")}
      >
        Неполная отгрузка
      </Checkbox>
    </VStack>
  );
});

export default IsReturnAndPaid;